import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '@/stores/auth-store';

import { listMembers } from './members-service';

export const membersQueryKey = ['organization-members'] as const;

export const useMembers = () => {
  const firebaseUser = useAuthStore((s) => s.firebaseUser);

  return useQuery({
    queryKey: membersQueryKey,
    queryFn: listMembers,
    enabled: !!firebaseUser?.emailVerified,
  });
};
